import { ISalesRepState } from '@/store/sales-rep';
import { ISalesRepGetters } from './getters.types';
import { IUser, User } from '@/models';

export const getters: ISalesRepGetters = {
  getSalesReps(state: ISalesRepState): IUser[] {
    return state.salesReps.map(data => new User(data));
  },

  getSalesRepById: (state: ISalesRepState) => (
    id: number
  ): IUser | undefined => {
    const data = state.salesReps.find(salesRep => salesRep.id === id);
    if (!data) {
      return undefined;
    }

    return new User(data);
  }
};
